export default __webpack_public_path__ + "src/images/packages/villa-one-hilltop/10c7fdd96e26b614fbe743f73caa16cc-4.jpg";